import script from "./DwApiView.vue?vue&type=script&setup=true&lang=js"
export * from "./DwApiView.vue?vue&type=script&setup=true&lang=js"

import "./DwApiView.vue?vue&type=style&index=0&id=0038f7e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0038f7e6"]])

export default __exports__